module.exports = __webpack_public_path__ + "static/media/swimming-pool.0f0b5e2f.svg";